var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',[_vm._v("\n\t"+_vm._s(_vm._f("truncate")(_vm.value,50))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }